var map = {
	"./Discord-hover.svg": "953e",
	"./Discord.svg": "6e4f",
	"./GitHub-hover.svg": "be4f",
	"./GitHub.svg": "e0b7",
	"./admin-hover.svg": "d739",
	"./admin.svg": "5928",
	"./blog-hover.svg": "8c87",
	"./blog.svg": "0a4f",
	"./close.svg": "f8c7",
	"./docs-hover.svg": "c7c6",
	"./docs.svg": "00c6",
	"./error.svg": "9fed",
	"./farming-hover.svg": "a205",
	"./farming.svg": "0a84",
	"./lang.svg": "6d3c",
	"./node.svg": "05fb",
	"./search-icon.svg": "afb2",
	"./stake-hover.svg": "9739",
	"./stake.svg": "6226",
	"./telegram-hover.svg": "3cbb",
	"./telegram.svg": "2d2c",
	"./wallet-hover.svg": "3d26",
	"./wallet.svg": "8299",
	"./whitepaper.svg": "d457",
	"./whiterpaper-hover.svg": "e47c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6e6";